<app-header />
<div id="myBody">
  <div class="container py-2 mx-auto min-vh-100">
    <div class="row d-flex justify-content-center">
      <div class="container-two rounded">
        <br>
        <div class="d-grid gap-1 d-md-flex header-card-color mb-2 rounded">
          <h6 class="tittle me-auto p-1 rounded"><i class="bi bi-person-fill"></i>&nbsp;<span>PERSONA: FÍSICA - FORANEO - EDICIÓN
            </span>
          </h6>
          <div>
            <h6 class="tittle me-auto p-1 rounded">
              <span><i class="bi bi-clipboard2-fill"></i>&nbsp;CERTIFICADO DE NO INFRACCIÓN</span>
            </h6>
          </div>
        </div>
        <mat-vertical-stepper [linear]="!isLinear" #stepper animationDuration="1500" class="container-one rounded">
          <mat-step [stepControl]="PrimerFormGroup">
            <form [formGroup]="PrimerFormGroup">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-car-front-fill"></i> DATOS DEL
                  VEHÍCULO &nbsp;</h6>
              </ng-template>
              <ng-template matStepLabel>
              </ng-template>

              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label" for="niv">NIV <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" placeholder="Escribe NIV" formControlName="niv" id="niv"
                    appAlphanumeric [minlength]="1" [maxlength]="17" autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('niv')?.invalid && PrimerFormGroup.get('niv')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="placa">PLACA <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" placeholder="Escribe placa" formControlName="placa" id="placa"
                    [minlength]="1" [maxlength]="10" appPlaca appPlaca
                    matTooltip="Ejemplo de cómo debes escribir tu placa: XUZ-99-99, WZ-99-999, TDZ-99"
                    matTooltipPosition="above" autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('placa')?.invalid && PrimerFormGroup.get('placa')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="motivoSolicitud">MOTIVO DE SOLICITUD <b
                      class="asteriscos">*</b></label>
                  <select type="text" class="form-select" formControlName="motivoSolicitud" id="motivoSolicitud"
                    matTooltip="Seleccionar 'Reposición de Placa y Tarjeta de Circulación' en caso de requerir únicamente Reposición de Placa"
                    matTooltipPosition="above" (change)="onChangeEfectoCertificado($event);">
                    <option value="" disabled selected>Selecciona una opción</option>
                    <option *ngFor="let motivo of efectosCertificados" [value]="motivo.id_efecto_certificado">{{motivo.motivo_de_solicitud}}</option>
                  </select>
                  <small
                    *ngIf="PrimerFormGroup.get('motivoSolicitud')?.invalid && PrimerFormGroup.get('motivoSolicitud')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="certificadoPor">CERTIFICADO POR: <b class="asteriscos">*</b></label>
                  <select class="form-select" formControlName="certificadoPor" id="certificadoPor" autocomplete="off"
                  (change)="onChangeCoberturaCertificados($event);">
                    <option value="" disabled selected>Selecciona una opción</option>
                    <option *ngFor="let certificado of coberturaCertificados" [value]="certificado.id_cobertura_certificado">{{certificado.certificado_por}}</option>
                  </select>
                  <small
                    *ngIf="PrimerFormGroup.get('certificadoPor')?.invalid && PrimerFormGroup.get('certificadoPor')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="tipoServicio">TIPO SERVICIO <b class="asteriscos">*</b></label>
                  <select class="form-select" formControlName="tipoServicio" id="tipoServicio" autocomplete="off"
                  (change)="onChangeTipoServicio($event);">
                    <option value="" disabled selected>Selecciona una opción</option>
                    <option value="1">PÚBLICO</option>
                    <option value="2">PRIVADO</option>
                  </select>
                  <small
                    *ngIf="PrimerFormGroup.get('tipoServicio')?.invalid && PrimerFormGroup.get('tipoServicio')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <!-- <div class="col-md-4">
                  <label class="form-label" for="categoria">CATEGORIA</label>
                  <input type="text" class="form-control" formControlName="categoria" id="categoria"
                    placeholder="Escribe la categoría" appLetters autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('categoria')?.invalid && PrimerFormGroup.get('categoria')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div> -->

                <div class="col-md-4">
                  <label class="form-label" for="marca">MARCA <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="marca" id="marca"
                    placeholder="Escribe la marca" appLetters autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('marca')?.invalid && PrimerFormGroup.get('marca')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="submarca">SUBMARCA <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="submarca" id="submarca"
                    placeholder="Escribe la submarca" appLetters autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('submarca')?.invalid && PrimerFormGroup.get('submarca')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="modelo">MODELO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="modelo" id="modelo"
                    placeholder="Escribe el modelo" [minlength]="4" [maxlength]="4" appNumeric
                    matTooltip="El modelo debe contener 4 números" matTooltipPosition="above" autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('modelo')?.invalid && PrimerFormGroup.get('modelo')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="motor">MOTOR <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="motor" id="motor"
                    placeholder="Escribe el motor" appAlphanumeric autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('motor')?.invalid && PrimerFormGroup.get('motor')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="refrendo">REFRENDO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="refrendo" id="refrendo"
                    placeholder="Escribe el refrendo" [minlength]="4" [maxlength]="4" appNumeric
                    matTooltip="El refrendo debe contener 4 números" matTooltipPosition="above" autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('refrendo')?.invalid && PrimerFormGroup.get('refrendo')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="repuve">REPUVE <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="repuve" id="repuve"
                    placeholder="Escribe el repuve" appAlphanumeric autocomplete="off">
                  <small *ngIf="PrimerFormGroup.get('repuve')?.invalid && PrimerFormGroup.get('repuve')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>
              </div>

              <div class="col-12 d-grid gap-1 d-md-flex justify-content-md-end mt-3">
                <button mat-raised-button color="primary" (click)="nextButtonClick()"
                  class="btn text-white buton-next d-flex align-items-center gap-2 rounded" matTooltip="Siguiente paso"
                  matTooltipPosition="above">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>
            </form>
          </mat-step>

          <!-- *************************************************************************************************************************************************************************************************************************** -->

          <mat-step [stepControl]="SegundoGrupo" label="Datos generales">
            <form [formGroup]="SegundoGrupo">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-person-fill"></i> DATOS PERSONALES &nbsp;
                </h6>
              </ng-template>

              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label" for="rfc">RFC <b class="asteriscos">*</b></label>
                  <div class="input-group">
                    <button type="button" class="btn button-modal" (click)="modalRFCFISICA()">
                      <i class="bi bi-info-circle-fill"></i>
                    </button>
                    <input type="text" class="form-control" placeholder="R.F.C. LLLL000000AAA" formControlName="rfc"
                      id="rfc" [minlength]="13" [maxlength]="13" (input)="pasarValorRfcACurp(); extractBirthday()"
                      appAlphanumeric
                      matTooltip="L = Letra , 0 = Número, A = Letra ó Número, Formato válido: LLLL000000AAA"
                      matTooltipPosition="above" autocomplete="off">
                  </div>
                  <small *ngIf="SegundoGrupo.get('rfc')?.invalid && SegundoGrupo.get('rfc')?.touched"
                    class="bg-danger text-white rounded">
                    <b> RFC no válido </b>
                  </small>

                  <small *ngIf="SegundoGrupo.get('rfc')?.valid && SegundoGrupo.get('rfc')?.touched"
                    class="bg-success text-white rounded" autocomplete="off">
                    <b> RFC válido </b>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="curp">CURP <b class="asteriscos">*</b></label>
                  <div class="input-group">
                    <button type="button" class="btn button-modal" (click)="modalCURP()">
                      <i class="bi bi-info-circle-fill"></i>
                    </button>
                    <input type="text" class="form-control" placeholder="CURP: LLLL000000LLLLLLA0"
                      formControlName="curp" id="curp" (input)="extraerSexoDesdeCurp()" [minlength]="18"
                      [maxlength]="18" appAlphanumeric
                      matTooltip="L = Letra , 0 = Número, A = Letra ó Número, Formato válido: LLLL000000LLLLLLA0"
                      matTooltipPosition="above" autocomplete="off">
                  </div>
                  <small *ngIf="SegundoGrupo.get('curp')?.invalid && SegundoGrupo.get('curp')?.touched"
                    class="bg-danger text-white rounded">
                    <b> CURP no válido </b>
                  </small>

                  <small *ngIf="SegundoGrupo.get('curp')?.valid && SegundoGrupo.get('curp')?.touched"
                    class="bg-success text-white rounded">
                    <b> CURP válido </b>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="nombre">NOMBRE <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="nombre" id="nombre"
                    placeholder="Escribe el nombre del propietario" appName autocomplete="off">
                  <small *ngIf="SegundoGrupo.get('nombre')?.invalid && SegundoGrupo.get('nombre')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="apellidoPaterno">APELLIDO PATERNO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="apellidoPaterno" id="apellidoPaterno"
                    placeholder="Escribe el apellido paterno" appName autocomplete="off">
                  <small
                    *ngIf="SegundoGrupo.get('apellidoPaterno')?.invalid && SegundoGrupo.get('apellidoPaterno')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="apellidoMaterno">APELLIDO MATERNO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="apellidoMaterno" id="apellidoMaterno"
                    placeholder="Escribe el apellido materno" appName autocomplete="off">
                  <small
                    *ngIf="SegundoGrupo.get('apellidoMaterno')?.invalid && SegundoGrupo.get('apellidoMaterno')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="sexo">SEXO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="sexo" id="sexo"
                    matTooltip="El sexo aparece según tu CURP" matTooltipPosition="above" autocomplete="off" [value]="SegundoGrupo.get('sexo')?.value === 'M' ? 'MASCULINO' : SegundoGrupo.get('sexo')?.value === 'F' ? 'FEMENINO' : ''" >
                  <small *ngIf="SegundoGrupo.get('sexo')?.invalid && SegundoGrupo.get('sexo')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="fechaNacimiento">FECHA NACIMIENTO <b class="asteriscos">*</b></label>
                  <input type="date" class="form-control" formControlName="fechaNacimiento" id="fechaNacimiento"
                    matTooltip="Tú Fecha de Nacimiento aparece según tu RFC como persona física (Representante), si el sistema se equivoca puedes ingresarla manualmente"
                    matTooltipPosition="above" autocomplete="off">
                  <small
                    *ngIf="SegundoGrupo.get('fechaNacimiento')?.invalid && SegundoGrupo.get('fechaNacimiento')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>
              </div>
              <br>

              <div class="d-flex bd-highlight mb-3">
                <!-- Botón Regresar -->
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                  matTooltipPosition="above"
                  class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <!-- Botón Siguiente -->
                <button mat-raised-button color="primary" (click)="nextButtonClick2()" matTooltip="Siguiente paso"
                  matTooltipPosition="above" class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son
                obligatorios</p>
            </form>
          </mat-step>



          <!-- *************************************************************************************************************************************************************************************************************************** -->

          <mat-step [stepControl]="TercerFormGroup" label="Datos generales">
            <form [formGroup]="TercerFormGroup">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-house-add-fill"></i> DOMICILIO &nbsp;
                </h6>
              </ng-template>

              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label" for="calle">CALLE <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="calle" id="calle"
                    placeholder="Escribe la calle" appDireccion autocomplete="off">
                  <small *ngIf="TercerFormGroup.get('calle')?.invalid && TercerFormGroup.get('calle')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="numeroExterior">No. EXTERIOR <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="numeroExterior" id="numeroExterior"
                    placeholder="Escribe el numero exterior" appDireccion autocomplete="off">
                  <small
                    *ngIf="TercerFormGroup.get('numeroExterior')?.invalid && TercerFormGroup.get('numeroExterior')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="numeroInterior">No. INTERIOR </label>
                  <input type="text" class="form-control" formControlName="numeroInterior" id="numeroInterior"
                    placeholder="Escribe el numero interior" appDireccion autocomplete="off">
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="codigoPostal">CÓDIGO POSTAL <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="codigoPostal" id="codigoPostal"
                    placeholder="Escribe el código postal" [minlength]="5" [maxlength]="5" appNumeric appNumeric
                    matTooltip="Tu código postal debe contener 5 números" matTooltipPosition="above" autocomplete="off">
                  <small
                    *ngIf="TercerFormGroup.get('codigoPostal')?.invalid && TercerFormGroup.get('codigoPostal')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="estado">ESTADO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" formControlName="estado" id="estado" readonly>
                  <!-- <select class="form-select" formControlName="estado" id="estado" autocomplete="off">
                    <option *ngFor="let est of estados" [value]="est"></option>
                  </select> -->
                  <small *ngIf="TercerFormGroup.get('estado')?.invalid && TercerFormGroup.get('estado')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="municipio">MUNICIPIO <b class="asteriscos">*</b></label>
                   <input type="text" class="form-control" formControlName="municipio" id="municipio" readonly>
                  <!-- <select class="form-select" formControlName="municipio" id="municipio" autocomplete="off">
                    <option *ngFor="let mun of municipios" [value]="mun">{{mun}}</option>
                  </select> -->
                  <small *ngIf="TercerFormGroup.get('municipio')?.invalid && TercerFormGroup.get('municipio')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="localidad">LOCALIDAD <b class="asteriscos">*</b></label>
                  <select class="form-select" formControlName="localidad" id="localidad" autocomplete="off"
                  >
                    <option *ngFor="let loc of localidadesLista" [value]="loc">{{loc}}</option>
                  </select>

                  <small *ngIf="TercerFormGroup.get('localidad')?.invalid && TercerFormGroup.get('localidad')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>
              </div>

              <br>
              <div class="d-flex bd-highlight mb-3">
                <!-- Botón Regresar -->
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                  matTooltipPosition="above"
                  class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <!-- Botón Siguiente -->
                <button mat-raised-button color="primary" (click)="nextButtonClick3()" matTooltip="Siguiente paso"
                  matTooltipPosition="above" class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son
                obligatorios</p>
            </form>
          </mat-step>


          <!-- *************************************************************************************************************************************************************************************************************************** -->

          <mat-step [stepControl]="CuartoFormGroup" label="Medios de Contacto">
            <form [formGroup]="CuartoFormGroup">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-telephone-plus-fill"></i> MEDIOS DE
                  CONTACTO &nbsp;</h6>
              </ng-template>

              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label" for="numeroTelefono">NÚMERO TELÉFONO <b class="asteriscos">*</b></label>
                  <input type="text" class="form-control" placeholder="Escribe tu Número de Teléfono" maxlength="10"
                    minlength="10" formControlName="numeroTelefono" id="numeroTelefono" appNumeric
                    matTooltip="tu número de teléfono debe contener 10 números" matTooltipPosition="above"
                    autocomplete="off">
                  <small
                    *ngIf="CuartoFormGroup.get('numeroTelefono')?.invalid && CuartoFormGroup.get('numeroTelefono')?.touched"
                    class="text-danger">
                    <p>Campo Obligatorio</p>
                  </small>
                </div>

                <div class="col-md-4">
                  <label class="form-label" for="correoElectronico">CORREO ELECTRÓNICO <b
                      class="asteriscos">*</b></label>
                  <input type="email" class="form-control" placeholder="Escribe tu Correo Electrónico"
                    formControlName="correoElectronico" id="correoElectronico"
                    matTooltip="Formato correo: nombre@ejemplo.com" matTooltipPosition="above" autocomplete="off">
                  <small
                    *ngIf="CuartoFormGroup.get('correoElectronico')?.invalid && CuartoFormGroup.get('correoElectronico')?.touched"
                    class="bg-danger text-white rounded">
                    <b> Correo Electrónico no válido </b>
                  </small>

                  <small
                    *ngIf="CuartoFormGroup.get('correoElectronico')?.valid && CuartoFormGroup.get('correoElectronico')?.touched"
                    class="bg-success text-white rounded">
                    <b> Correo Electrónico válido </b>
                  </small>
                </div>
              </div>
              <br>

              <div class="d-flex bd-highlight mb-3">
                <!-- Botón Regresar -->
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                  matTooltipPosition="above"
                  class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <!-- Botón Siguiente -->
                <button mat-raised-button color="primary" (click)="nextButtonClick4()" matTooltip="Siguiente paso"
                  matTooltipPosition="above" class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>
            </form>
          </mat-step>

          <!-- *************************************************************************************************************************************************************************************************************************** -->

          <mat-step [stepControl]="QuintoFormGroup" label="Medios de Contacto">
            <form [formGroup]="QuintoFormGroup">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-file-arrow-down-fill"></i> DESCARGAR
                  DOCUMENTO &nbsp;</h6>
              </ng-template>

              <!-- Alerta principal: instrucciones iniciales y descarga -->
              <div class="container alert alert-light shadow-lg rounded p-4">
                <p class="fw-bold text-uppercase mb-3">
                  Instrucciones de la SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN
                </p>
                <p class="text-justify mb-2">
                  Para completar este trámite, siga los siguientes pasos cuidadosamente:
                </p>
                <ol class="mb-3">
                  <li><b>Descargue</b> el formato de <b>SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b>, haciendo clic en el botón <b>“Descargar formato de solicitud”</b> que se muestra abajo.</li>
                  <li><b>Firme</b> el formato de solicitud descargado.</li>
                  <li><b>Escanee</b> el formato de solicitud ya firmado y  <b>guárdelo</b> en formato <b>PDF</b> en su dispositivo.
                  </li>
                  <li>Una vez que tenga el archivo listo, de clic en el botón <b>Siguiente</b> para continuar a la sección de
                    <b>DOCUMENTOS</b>.
                  </li>
                </ol>
                <div class="text-center">
                  <button type="button" mat-flat-button color="primary" class="mb2" (click)="descargarDocumento()">
                    <i class="bi bi-cloud-arrow-down-fill me-2"></i> Descargar formato de solicitud
                  </button>
                </div>
                <br>
                <div class="col-12 shadow p-3 rounded margin bg-white">
                  <div class="ml-2 form-check">
                    <input class="form-check-input" type="checkbox" formControlName="descargarDocumento"
                      id="descargarDocumento">
                   <label class="form-check-label" for="descargarDocumento">
                      Tengo listo el <b>Formato de solicitud </b> y deseo continuar a la siguiente sección. <b class="asteriscos">*</b>
                    </label>
                    <div class="invalid-feedback">
                      debes aceptar para continuar
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex bd-highlight mb-3">
                <!-- Botón Regresar -->
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                  matTooltipPosition="above"
                  class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <!-- Botón Siguiente -->
                <button mat-raised-button color="primary" (click)="nextButtonClick5()" matTooltip="Siguiente paso"
                  matTooltipPosition="above" class="btn buton-next text-white d-flex align-items-center gap-2 rounded">
                  Siguiente <i class="bi bi-caret-right-fill"></i>
                </button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>

            </form>
          </mat-step>

          <!-- *************************************************************************************************************************************************************************************************************************** -->

          <mat-step [stepControl]="SextoFormGroup" label="Medios de Contacto">
            <form [formGroup]="SextoFormGroup">
              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-file-pdf-fill"></i> DOCUMENTOS &nbsp;</h6>
              </ng-template>

              <!-- Alerta separada: Instrucciones paso a paso para subir documentos solicitados -->
              <div class="container alert alert-light shadow-sm rounded p-4 mt-3">
                <h5 class="text-center text-primary mb-3"><b>Instrucciones para la carga de documentos solicitados</b>
                </h5>
                <ol class="mb-3">
                  <li>Revise cuidadosamente los documentos que la plataforma le solicita.</li>
                  <li>Asegúrese de tener cada documento en formato <b>PDF</b>.</li>
                  <li>Para cada documento solicitado:
                    <ul class="mt-2">
                      <li>Presione el botón con el ícono
                        <i class="bi bi-cloud-arrow-up-fill text-primary mx-1" style="font-size: 18px;"></i>
                        para <b>adjuntar el archivo</b> desde su dispositivo.
                      </li>
                      <li>Use el botón con el ícono
                        <i class="bi bi-eye-fill text-success mx-1" style="font-size: 18px;"></i>
                        para <b>visualizar el archivo</b> antes de enviarlo.
                      </li>
                    </ul>
                  </li>
                </ol>
                <p><strong>Nota: </strong>En el documento <strong>Factura</strong>. </p>

                <ul>
                  <li>Si su vehículo fue refacturado, debe anexar el seguimiento o el historial de facturas.</li>
                  <li>Si su vehículo tiene factura digital, debe anexar su comprobante fiscal.</li>
                  <li>
                    Para unidades del año <b>2014</b> en adelante, anexar contrato de
                    compraventa junto con la identificación oficial <b>(INE)</b> del vendedor y del
                    comprador.
                  </li>
                  <li>
                    Para modelos del año <b>2013</b> o anteriores, ya no es necesario presentar el contrato
                    de compraventa.
                  </li>
                </ul>
              </div>

              <div class="row justify-content-center">
                <div class="card cards me-2 mt-2" style="width: 18rem;">
                  <div class="card-body">
                    <ng-container *ngIf="pdfURL1; else noPdf">
                      <iframe [src]="pdfURL1" width="100%" height="300"
                        class="rounded border mb-2 card-iframe"></iframe>
                    </ng-container>

                    <ng-template #noPdf>
                      <div class="text-center card-iframe mb-2" style="height: 300px;"></div>
                    </ng-template>

                    <!-- Barra de progreso -->
                    <div *ngIf="isUploading[0]" class="progress mb-2">
                      <div class="progress-bar custom-progress-bar" role="progressbar" 
                        [style.width.%]="uploadProgress[0]"
                        [attr.aria-valuenow]="uploadProgress[0]" aria-valuemin="0" aria-valuemax="100"
                        matTooltip="Cargando documento..." matTooltipPosition="above">
                        {{ uploadProgress[0] }}%
                      </div>
                    </div>

                    <div class="text-center">
                      <div class="input-group mb-3 justify-content-center">

                        <input type="file" #fileInput1 accept=".pdf" 
                          (change)="onFileSelecteded1(fileInput1,8); archivoSelecionadoPDF1($event,0)"
                          style="display: none" />

                        <button [disabled]="checkboxSolicitud" type="button" class="btn button-upload" (click)="fileInput1.click()"
                          matTooltip="Seleccionar Documento descargado previamente" matTooltipPosition="left">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </button>

                        <button type="button" class="btn watch-custom" matTooltip="Ver Documento"
                          matTooltipPosition="above" (click)="abrirPDFNewVentana1()" [disabled]="!pdfURL1">
                          <i class="bi bi-eye-fill"></i>
                        </button>

                        <div class="input-group-text check-jefe-departamento" [matTooltip]="checkboxSolicitud ? 'Validado por el administrador' : ''"
                    matTooltipPosition="above">
                    <input [checked]="checkboxSolicitud"  class="form-check-input mt-0" type="checkbox" 
                      disabled>
                  </div>

                      </div>
                      <hr />
                      <h6 class="card-title tittle text-center rounded">SOLICITUD</h6>
                    </div>
                  </div>
                </div>

                <div class="card cards me-2 mt-2" style="width: 18rem;">
                  <div class="card-body">
                    <ng-container *ngIf="pdfURL2; else noPdf">
                      <iframe [src]="pdfURL2" width="100%" height="300"
                        class="rounded border mb-2 card-iframe"></iframe>
                    </ng-container>

                    <ng-template #noPdf>
                      <div class="text-center card-iframe mb-2" style="height: 300px;"></div>
                    </ng-template>

                    <!-- Barra de progreso -->
                    <div *ngIf="isUploading[1]" class="progress mb-2">
                      <div class="progress-bar custom-progress-bar" role="progressbar" 
                        [style.width.%]="uploadProgress[1]"
                        [attr.aria-valuenow]="uploadProgress[1]" aria-valuemin="0" aria-valuemax="100"
                        matTooltip="Cargando documento..." matTooltipPosition="above">
                        {{ uploadProgress[1] }}%
                      </div>
                    </div>

                    <div class="text-center">
                      <div class="input-group mb-3 justify-content-center">

                        <input type="file" #fileInput2 accept=".pdf" 
                          (change)="onFileSelecteded2(fileInput2,3); archivoSelecionadoPDF2($event,1)"
                          style="display: none" />

                        <button [disabled]="checkboxFactura" type="button" class="btn button-upload" (click)="fileInput2.click()"
                          matTooltip="Seleccionar Documento, FACTURA debe ser digitalizado por ambos lados" matTooltipPosition="left">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </button>

                        <button type="button" class="btn watch-custom" matTooltip="Ver Documento"
                          matTooltipPosition="above" (click)="abrirPDFNewVentana2()" [disabled]="!pdfURL2">
                          <i class="bi bi-eye-fill"></i>
                        </button>

                        <div class="input-group-text check-jefe-departamento" [matTooltip]="checkboxFactura ? 'Validado por el administrador' : ''"
                    matTooltipPosition="above">
                    <input [checked]="checkboxFactura"  class="form-check-input mt-0" type="checkbox" 
                      disabled>
                  </div>
                      </div>
                      <hr />
                      <h6 class="card-title tittle text-center rounded">FACTURA</h6>
                    </div>

                  </div>
                </div>

                <div class="card cards me-2 mt-2" style="width: 18rem;">
                  <div class="card-body">
                    <ng-container *ngIf="pdfURL3; else noPdf">
                      <iframe [src]="pdfURL3" width="100%" height="300"
                        class="rounded border mb-2 card-iframe"></iframe>
                    </ng-container>

                    <ng-template #noPdf>
                      <div class="text-center card-iframe mb-2" style="height: 300px;"></div>
                    </ng-template>

                    <!-- Barra de progreso -->
                    <div *ngIf="isUploading[2]" class="progress mb-2">
                      <div class="progress-bar custom-progress-bar" role="progressbar" 
                        [style.width.%]="uploadProgress[2]"
                        [attr.aria-valuenow]="uploadProgress[2]" aria-valuemin="0" aria-valuemax="100"
                        matTooltip="Cargando documento..." matTooltipPosition="above">
                        {{ uploadProgress[2] }}%
                      </div>
                    </div>

                    <div class="text-center">
                      <div class="input-group mb-3 justify-content-center">

                        <input type="file" #fileInput3 accept=".pdf" 
                          (change)="onFileSelecteded3(fileInput3,4); archivoSelecionadoPDF3($event,2)"
                          style="display: none" />


                          
                        <button [disabled]="checkboxINE" type="button" class="btn button-upload" (click)="fileInput3.click()"
                          matTooltip="Seleccionar Documento, INE debe ser digitalizado por ambos lados" matTooltipPosition="left">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </button>

                        <button type="button" class="btn watch-custom" matTooltip="Ver Documento"
                          matTooltipPosition="above" (click)="abrirPDFNewVentana3()" [disabled]="!pdfURL3">
                          <i class="bi bi-eye-fill"></i>
                        </button>

                         <div class="input-group-text check-jefe-departamento" [matTooltip]="checkboxINE ? 'Validado por el administrador' : ''"
                    matTooltipPosition="above">
                    <input [checked]="checkboxINE"  class="form-check-input mt-0" type="checkbox" 
                      disabled>
                  </div>

                      </div>
                      <hr />
                      <h6 class="card-title tittle text-center rounded">INE</h6>
                    </div>
                  </div>
                </div>

                <div class="card cards me-2 mt-2" style="width: 18rem;">
                  <div class="card-body">
                    <ng-container *ngIf="pdfURL4; else noPdf">
                      <iframe [src]="pdfURL4" width="100%" height="300"
                        class="rounded border mb-2 card-iframe"></iframe>
                    </ng-container>

                    <ng-template #noPdf>
                      <div class="text-center card-iframe mb-2" style="height: 300px;"></div>
                    </ng-template>

                    <!-- Barra de progreso -->
                    <div *ngIf="isUploading[3]" class="progress mb-2">
                      <div class="progress-bar custom-progress-bar" role="progressbar" 
                        [style.width.%]="uploadProgress[3]"
                        [attr.aria-valuenow]="uploadProgress[3]" aria-valuemin="0" aria-valuemax="100"
                        matTooltip="Cargando documento..." matTooltipPosition="above">
                        {{ uploadProgress[3] }}%
                      </div>
                    </div>

                    <div class="text-center">
                      <div class="input-group mb-3 justify-content-center">

                        <input type="file" #fileInput4 accept=".pdf" 
                          (change)="onFileSelecteded4(fileInput4,7); archivoSelecionadoPDF4($event,3)"
                          style="display: none" />

                        <button [disabled]="checkboxRepuve" type="button" class="btn button-upload" (click)="fileInput4.click()"
                          matTooltip="Seleccionar Documento" matTooltipPosition="left">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </button>

                        <button type="button" class="btn watch-custom" matTooltip="Ver Documento"
                          matTooltipPosition="above" (click)="abrirPDFNewVentana4()" [disabled]="!pdfURL4">
                          <i class="bi bi-eye-fill"></i>
                        </button>

                        <div class="input-group-text check-jefe-departamento" [matTooltip]="checkboxRepuve ? 'Validado por el administrador' : ''"
                        matTooltipPosition="above">
                        <input [checked]="checkboxRepuve" class="form-check-input mt-0" type="checkbox" 
                          disabled>
                  </div>

                      </div>
                      <hr />
                      <h6 class="card-title tittle text-center rounded">REPUVE</h6>
                    </div>
                  </div>
                </div>


                <div class="card cards me-2 mt-2" style="width: 18rem;">
                  <div class="card-body">
                    <ng-container *ngIf="pdfURL5; else noPdf">
                      <iframe [src]="pdfURL5" width="100%" height="300"
                        class="rounded border mb-2 card-iframe"></iframe>
                    </ng-container>

                    <ng-template #noPdf>
                      <div class="text-center card-iframe mb-2" style="height: 300px;"></div>
                    </ng-template>

                    <!-- Barra de progreso -->
                    <div *ngIf="isUploading[4]" class="progress mb-2">
                      <div class="progress-bar custom-progress-bar" role="progressbar" 
                        [style.width.%]="uploadProgress[4]"
                        [attr.aria-valuenow]="uploadProgress[4]" aria-valuemin="0" aria-valuemax="100"
                        matTooltip="Cargando documento..." matTooltipPosition="above">
                        {{ uploadProgress[4] }}%
                      </div>
                    </div>

                    <div class="text-center">
                      <div class="input-group mb-3 justify-content-center">

                        <input type="file" #fileInput5 accept=".pdf" 
                          (change)="onFileSelecteded5(fileInput5,9); archivoSelecionadoPDF5($event,4)"
                          style="display: none" />

                        <button [disabled]="checkboxTenenciaRefrendo" type="button" class="btn button-upload" (click)="fileInput5.click()"
                          matTooltip="Seleccionar Documento" matTooltipPosition="left">
                          <i class="bi bi-cloud-arrow-up-fill"></i>
                        </button>

                        <button type="button" class="btn watch-custom" matTooltip="Ver Documento"
                          matTooltipPosition="above" (click)="abrirPDFNewVentana5()" [disabled]="!pdfURL5">
                          <i class="bi bi-eye-fill"></i>
                        </button>

                         <div class="input-group-text check-jefe-departamento" [matTooltip]="checkboxTenenciaRefrendo ? 'Validado por el administrador' : ''"
                        matTooltipPosition="above">
                        <input [checked]="checkboxTenenciaRefrendo"  class="form-check-input mt-0" type="checkbox"
                        disabled>
                  </div>

                      </div>
                      <hr />
                      <h6 class="card-title tittle text-center rounded">TENENCIA Y/O REFRENDO</h6>
                    </div>
                  </div>
                </div>


               
               

              </div>
              <br>
              <div class="d-flex bd-highlight mb-3">
                <button matStepperPrevious class="btn buton-back text-white  me-auto p-2 bd-highlight"
                  matTooltip="Paso anterior" matTooltipPosition="above"><i class="bi bi-caret-left-fill"></i>
                  Regresar</button>
                <button (click)="nextButtonClick6()" class="btn buton-next text-white" matTooltip="Siguiente paso"
                  matTooltipPosition="above">Siguiente <i class="bi bi-caret-right-fill"></i></button>
              </div>

              <hr>
              <p class="texto-obligatorio">Los campos con ( <b class="asteriscos">*</b> ) son obligatorios
              </p>

            </form>
          </mat-step>

          <!-- *************************************************************************************************************************************************************************************************************************** -->
          <mat-step [stepControl]="SeptimoFormGroup" label="Termino de Revision">
            <form [formGroup]="SeptimoFormGroup">

              <ng-template matStepLabel>
                <h6 class="text-desktop tittle rounded">&nbsp;<i class="bi bi-pencil-square"></i> AVISO DE CONFORMIDAD
                  &nbsp;</h6>
              </ng-template>

              <br>
              <div class="row g-3 alert alert-light shadow-lg p-3 mb-5 rounded">
                <br>
                <figure>
                  <blockquote class="blockquote">
                    <p>Acepto que los servicios que a través de este medio se
                      pagan,
                      se sujeten a los requisitos que las disposiciones fiscales y administrativas
                      señalen
                      para tales efectos
                      y que en caso de no cumplir con aquéllos, quede expedito mi derecho para
                      solicitar
                      la devolución de este pago,
                      conforme a derecho corresponda.</p>
                    <hr>
                  </blockquote>
                </figure>


                <div class="col-12 shadow p-3 rounded margin bg-white">
                  <div class="ml-2 form-check">
                    <input class="form-check-input" type="checkbox" formControlName="terminosCondiciones"
                      id="terminosCondiciones">
                    <label class="form-check-label" for="terminosCondiciones">
                      He
                      leído y acepto los
                      <a href="#" role="button" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        Términos y condiciones
                      </a> <b class="asteriscos">*</b>
                    </label>
                    <div class="invalid-feedback">
                      Primero debes aceptar los términos y condiciones.
                    </div>
                  </div>
                </div>
              </div>


              <div class="modal fade text-center" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false"
                tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header header-modal">
                      <h5 class="modal-title" id="staticBackdropLabel">AVISO DE PRIVACIDAD</h5>
                      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <h5 class="fw-bold text-start">
                        Aviso de Privacidad Simplificado
                      </h5>

                      <p class="text-start">
                        Con fundamento en los artículos 17 y 18 de la Ley de Protección de Datos Personales en Posesión
                        de Sujetos Obligados del Estado de Tlaxcala, la Secretaría de Movilidad y Transporte del Estado
                        de Tlaxcala, procede a emitir el Aviso de Privacidad Simplificado, para la sociedad que
                        acude a realizar trámites en esta Secretaría.
                      </p>

                      <p class="text-start">
                        Esta Secretaría podrá recabar los datos personales siguientes: nombre completo, domicilio, edad,
                        género, nivel de escolaridad, RFC, CURP, huellas dactilares, tipo de sangre, correo electrónico,
                        teléfono y firma. Además, pueden ser recabados y tratados datos vehiculares, tales como: número
                        de identificación vehicular (NIV) y placa de circulación. Y datos sensibles, tales como
                        dictámenes médicos.
                      </p>

                      <p class="text-start">
                        Los datos personales recabados serán utilizados para las finalidades siguientes: realizar los
                        trámites y servicios en materia de transporte público y privado, así como la expedición de
                        licencia de conducir, en sus modalidades presencial y virtual a través de la plataforma en
                        línea. De manera adicional, los datos personales proporcionados podrán ser utlilizados con fines
                        estadísticos, registros de control e informes sobre el servicio brindado.
                      </p>

                      <p class="text-start">
                        Le informamos que los datos proporcionados serán transferidos a la Secretaría de Finanzas del
                        Estado de Tlaxcala con fines recaudatorios, de acuerdo al artículo 1 de la Ley
                        de Ingresos para el Estado de Tlaxcala.
                      </p>

                      <p class="text-start">
                        En el ejercicio de la protección de us datos personales, usted como titular podrá manifestar lo
                        correspondiente en el tratamiento de los mismos, mediante un escrito libre dirigido a la Unidad
                        de Transparencia o al Oficial de Protección de Datos Personales de esta Secretaría, al correo
                        electrónico: <strong>transparencia&#64;smytlax.gob.mx</strong>, o al teléfono <strong>246
                          465 2960</strong> ext. <strong>3304</strong>, con horario de atención de lunes a viernes de
                        08:00 a 17:00 horas.
                      </p>

                      <p class="text-start">
                        Usted está consultando el Aviso de Privacidad Simplificado para la sociedad que acude a realizar
                        trámites a la Secretaría de Movilidad y Transporte de manera presencial o en su modalidad
                        virtual.

                      <p class="text-start">
                        El sitio donde podrá consultar el Aviso de Privacidad Integral es:
                        <a href="https://smyt.tlaxcala.gob.mx/" target="_blank"
                          class="fw-bold text-decoration-underline">https://smyt.tlaxcala.gob.mx/</a>
                      </p>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn button-close" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex bd-highlight mb-3">
                <!-- Botón Regresar -->
                <button mat-raised-button color="primary" matStepperPrevious matTooltip="Paso anterior"
                  matTooltipPosition="above"
                  class="btn buton-back text-white me-auto p-2 bd-highlight d-flex align-items-center gap-2 rounded">
                  <i class="bi bi-caret-left-fill"></i> Regresar
                </button>

                <div>
                  <!-- Botón Guardar -->
                  <button mat-raised-button color="primary" (click)="nextButtonClick7()"
                    matTooltip="Guardar toda la información" matTooltipPosition="above"
                    class="btn button-save text-white d-flex align-items-center gap-2 rounded">
                    <mat-icon>save</mat-icon> Guardar Cambios
                  </button>
                </div>
              </div>

              <hr>
            </form>
          </mat-step>
        </mat-vertical-stepper>
        <br>
      </div>
    </div>
  </div>
</div>

<div class="blur-container" *ngIf="mostrarSpinner">
  <div class="spinner-container">
    <img src="/assets/Spinner/Logotipo.png" class="rotating-image mb-2" alt="Spinner">
    <p class="loading-text"><b>Procesando, por favor espere...</b></p>
  </div>
</div>

<app-footer />


